import { PaymentFollowUpState } from '../../types/paymentFollowUps'
import { PaymentInvestigationKind } from '../../types/paymentInvestigations'
import { parseReservationNumber } from './filters'

export const INVESTIGATION_KINDS: PaymentInvestigationKind[] = [
  'FundingAllocationUnreconstructable',
  'WalletReleaseAttributionUnknown'
]
export interface InvestigationFilters {
  state: PaymentFollowUpState
  kind: PaymentInvestigationKind | ''
  reservationNumber: number | null
}
export const defaultInvestigationFilters = (): InvestigationFilters => ({
  state: 'Open',
  kind: '',
  reservationNumber: null
})
export function parseInvestigationNumber(input: string): number | null {
  const number = parseReservationNumber(input)
  return number !== null && number <= 2147483647 ? number : null
}
export function readInvestigationFilters(search: string): InvestigationFilters {
  const raw = new URLSearchParams(search).get('investigationFilter')
  if (!raw || raw.length > 1024) return defaultInvestigationFilters()
  try {
    const value: unknown = JSON.parse(raw)
    if (!value || typeof value !== 'object' || Array.isArray(value))
      return defaultInvestigationFilters()
    const filter = value as Record<string, unknown>
    if (filter.state !== 'Open' && filter.state !== 'Resolved')
      return defaultInvestigationFilters()
    const kind = INVESTIGATION_KINDS.find((item) => item === filter.kind) ?? ''
    if (filter.kind !== undefined && filter.kind !== '' && !kind)
      return defaultInvestigationFilters()
    const reservationNumber =
      typeof filter.reservationNumber === 'number'
        ? parseInvestigationNumber(String(filter.reservationNumber))
        : null
    if (filter.reservationNumber !== undefined && reservationNumber === null)
      return defaultInvestigationFilters()
    return { state: filter.state, kind, reservationNumber }
  } catch {
    return defaultInvestigationFilters()
  }
}
export function writeInvestigationFilters(
  search: string,
  filter: InvestigationFilters
): string {
  const params = new URLSearchParams(search)
  if (
    filter.state === 'Open' &&
    !filter.kind &&
    filter.reservationNumber === null
  ) {
    params.delete('investigationFilter')
  } else {
    params.set(
      'investigationFilter',
      JSON.stringify({
        state: filter.state,
        ...(filter.kind ? { kind: filter.kind } : {}),
        ...(filter.reservationNumber !== null
          ? { reservationNumber: filter.reservationNumber }
          : {})
      })
    )
  }
  return `?${params.toString()}`
}
